import styled from 'styled-components';

const StyledGradient = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	background: linear-gradient(90deg, #101318, rgba(16, 19, 24, 0));
	width: 900px;
	height: 100%;
`;

export { StyledGradient };
